import * as types from './types';
import { execApi, execApiWithParam } from '../api/apiActions';
import { closeAlertDialog, openErrorDialog, openSuccessDialog  } from '../dialog/dialogActions';
import ProfileApi from '../../apis/profile';


export const getProfile = () => {
  return dispatch => {
    dispatch(execApi({
      type: types.GET_PROFILE,
      api: ProfileApi.getProfile,
      successCallback: response => {
        dispatch({
          type: types.GET_PROFILE,
          payload: response,
        });
      },
      // Our 'success: false' response object. Also called on catch of an exception.
      errorCallback: response => {
        dispatch(openErrorDialog({
          title: response.message.title,
          content: response.message.body,
        }));
      },
      useErrorDialog: true,
    }));
  };
};

// Passed a successCb to close ChangePassword's internal Dialog
export const updatePassword = (formValues, successCb) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.UPDATE_PASSWORD,
      api: ProfileApi.updatePassword,
      param: formValues,
      successCallback: response => {

        if (successCb) successCb(response);

        dispatch(openSuccessDialog({
          title: 'Password updated!',
          // getProfile() after we update
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getProfile());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};

export const updateProfile = (formValues) => {
  return dispatch => {
    dispatch(execApiWithParam({
      type: types.UPDATE_PROFILE,
      api: ProfileApi.updateProfile,
      param: formValues,
      successCallback: response => {
        dispatch(openSuccessDialog({
          title: 'Profile updated!',
          // getProfile() after we update
          okCallback: () => {
            dispatch(closeAlertDialog());
            dispatch(getProfile());
          },
        }));
      },
      useErrorDialog: true,
    }));
  };
};



// WEBPACK FOOTER //
// ./src/actions/profile/profileActions.js